export default __webpack_public_path__ + "static/media/LavieSport.0dbd57cd.jpg";